import React, { useContext } from "react";
import { RootStoreContext } from "../store/rootStore";
import { observer } from "mobx-react-lite";
import CoCurricularCard from "./CoCurricularCard";


const CoCurricularCards:React.FC = observer(() => {

  const rootStore = useContext(RootStoreContext);

  const {filteredCards} = rootStore.coCurricularStore;

  
  return (
    <>
      {filteredCards.length > 0 ? 
        <>
          <p className='specialist-modules__header'>Activities vary slightly year to year depending on pupil demand. If you are currently at Dollar Academy please check SOCs for the most up-to-date info or to book.</p>
          <div className='cc-wall'>
            {filteredCards.map((card, index) => (
              <CoCurricularCard key={card.slug} index={index} card={card} />
            ))}
          </div>
        </>
        :
        <div>
          <p style={{textAlign: 'center', fontSize: 20}}>Sorry, there are no results matching your selection.</p>
        </div>
      }
    </>
  );

});

export default CoCurricularCards;